import React from 'react'
import createReactClass from 'create-react-class';
import moment from 'moment'

export default createReactClass({

	notices: {
		'2017': {
			'03': {
				'06': {
					title: 'Pitching and Presentation',
					message: 'Article at 5pm. Workshop at 7pm. Video at 8pm.'
				},
				'07': {
					title: 'Business Development',
					message: 'Article at 5pm. Video session and live Q&A at 7pm.'
				},
				'08': {
					title: 'Customers as Advocates',
					message: 'Article at 5pm. Video at 7pm.'
				},
				'09': {
					title: 'Ecommerce',
					message: 'Article at 5pm. Workshop at 7pm.'
				},
				'10': {
					title: 'Customer service',
					message: 'Article at 5pm. Video at 7pm.'
				}
			}
		}
	},

	shouldComponentUpdate: function() {
		return false
	},

	render: function() {

		let year = moment().format('YYYY'),
			month = moment().format('MM'),
			day = moment().format('DD'),
			notice = !(year in this.notices) 
				? false
				: !(month in this.notices[year])
					? this.notices[year]
					: !(day in this.notices[year][month])
						? this.notices[year][month]
						: this.notices[year][month][day]

		return (
			('title' in notice) && 
				<div className="pbot30 text-center text-dark-grey">
					<h4 className="mtop0">Coming Today</h4>
					<div>
						<p><strong>{notice.title}</strong></p>
						<p className="small">{notice.message}</p>
					</div>
				</div>
		)

	}

})



// WEBPACK FOOTER //
// ./src/js/views/Community/DashboardParts/TodaysNotice.jsx